import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import { ImageInput, ImageField, TextInput } from "react-admin";
import { useUpdate, useNotify, useTranslate } from "react-admin";
import ReactS3Client from "react-aws-s3-typescript";
import { s3Config } from "../../dataProvider/s3Config";
import util from "util";
import fs from "fs";
import AWS from "aws-sdk";
import dotenv from "dotenv";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

type Props = {
  sourceName: string,
  multiple: boolean
}

const UploadImages = ({ sourceName, multiple }: Props) => {
  const classes = useStyles();
  const [isChanged, setChange] = useState<boolean>();
  const [files, setFiles] = useState<any[]>([]);
  const translate = useTranslate();

  const handleChange = (value: any) => {
    console.log("handleChange")
    converttonew(value);
    if (value.length > 0) {
      setChange(true);
    } else {
      setChange(true);
    }
    setFiles(value);
  };

  const handleClick = (event: any) => {
    console.log("Heeeeeeey form handlClick", Array.isArray(files));
    if(Array.isArray(files)){
      for (let i = 0; i < files.length; i++) {
        console.log("length:", files.length)
        if (i === files.length - 1) {
          handleUpload(files[i]);
        } else handleUpload(files[i]);
      }
    }
    else{
      handleUpload(files)
    }

  };

  const converttonew = (event: any) => {
    const recipes_1 =  
    [
      {
          "id": 1,
          "title": "Mazola Jalapeno Creamy Chicken Tortillas",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/IabAKNzBcDI-SD.jpg",
          "views": 100,
          "video_url": "IabAKNzBcDI"
      },
      {
          "id": 2,
          "title": "Sandwich Tray With Mazola Mayo",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/oVbQJKBgRVg-HD.jpg",
          "views": 100,
          "video_url": "oVbQJKBgRVg"
      },
      {
          "id": 3,
          "title": "Cocktail Sauce Recipe",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/CnNVbzOA-rE-HQ.jpg",
          "views": 100,
          "video_url": "CnNVbzOA-rE"
      },
      {
          "id": 4,
          "title": "Crazy Chicken Popcorn Slider",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/bZGIEsf4bRM-HQ.jpg",
          "views": 100,
          "video_url": "bZGIEsf4bRM"
      },
      {
          "id": 5,
          "title": "",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/dz2-VGKVmZk-SD.jpg",
          "views": 100,
          "video_url": "dz2-VGKVmZk"
      },
      {
          "id": 6,
          "title": "Mazola Recipe",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/wqmGMUbpJKU-SD.jpg",
          "views": 100,
          "video_url": "wqmGMUbpJKU"
      },
      {
          "id": 7,
          "title": "Mazola Recipe Avocado Salad Sandwich",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/RJVCcIw2tTk-SD.jpg",
          "views": 100,
          "video_url": "RJVCcIw2tTk"
      },
      {
          "id": 8,
          "title": "Mazola Pizza Rolls Recipe ",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/FsMbHqrlsaU-HD.jpg",
          "views": 100,
          "video_url": "FsMbHqrlsaU"
      },
      {
          "id": 9,
          "title": "Mazola Recipe Salad",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/xe5mUSpgTdk-SD.jpg",
          "views": 100,
          "video_url": "xe5mUSpgTdk"
      },
      {
          "id": 10,
          "title": "",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/6Is4vvpF4K0-SD.jpg",
          "views": 100,
          "video_url": "6Is4vvpF4K0"
      },
      {
          "id": 11,
          "title": "Mazola Recipe Shrimp Tacos",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/jY981VFI5BM-HD.jpg",
          "views": 100,
          "video_url": "jY981VFI5BM"
      },
      {
          "id": 12,
          "title": "Mazola Recipe French Fries With Jalapenos",
          "description": null,
          "type": 1,
          "thumbnail": "https://www.mazola.com.sa/uploads/images/6WG_aLjavHU-HD.jpg",
          "views": 100,
          "video_url": "6WG_aLjavHU"
      },
      {
          "id": 65,
          "title": "aboutb news",
          "description": "description description",
          "type": 1,
          "thumbnail": "home.png",
          "views": 30000,
          "video_url": "https://www.youtube.com/watch?v=nyd-xznCpJc"
      }
  ]
    ;
          


    const recipes_2 =
        {
            "id": 1,
            "name_en": "Croissants 1",
            "name_ar": "Croissants 1",
            "featured_image": "https://www.mazola.com.sa/uploads/images/croissant-min.jpg",
            "images": [{"url": "https://mazola-prod.s3.me-south-1.amazonaws.com/uploads/products/6281003105013/1.png", "name": "Screen Shot 2023-01-11 at 23.06.51.png"}, {"url": "https://mazola-prod.s3.me-south-1.amazonaws.com/Screen Shot 2023-01-11 at 23.07.35.png", "name": "Screen Shot 2023-01-11 at 23.07.35.png"}, {"url": "https://mazola-prod.s3.me-south-1.amazonaws.com/Screen Shot 2023-01-11 at 23.08.04.png", "name": "Screen Shot 2023-01-11 at 23.08.04.png"}],
            "ingredients_en": "<ul><li>1 kilo of flour</li><li>3 tablespoons of yeast</li><li>3 tablespoons of sugar</li><li>3 tablespoons of powdered milk</li><li>1 tablespoon salt</li><li>2 eggs</li><li>1/2 cup milk</li><li>1/2 cup of shortening from Mazola</li></ul>",
            "ingredients_ar": "<ul><li>1- Mix the dry ingredients together, then make a hole in the middle</li><li>2- Beat the eggs a little in a small plate until the whites mix with the yolks, then put them in the hole with the milk and shortening and rub the ingredients well</li><li",
            "instruction_en": "<ul><li>1- Mix the dry ingredients together, then make a hole in the middle</li><li>2- Beat the eggs a little in a small plate until the whites mix with the yolks, then put them in the hole with the milk and shortening and rub the ingredients well</li><li",
            "instruction_ar": "<ul><li>1- Mix the dry ingredients together, then make a hole in the middle</li><li>2- Beat the eggs a little in a small plate until the whites mix with the yolks, then put them in the hole with the milk and shortening and rub the ingredients well</li><li",
            "active": 1,
            "created_at": "2023-01-28T18:53:52.000Z",
            "updated_at": "2023-01-28T18:53:52.000Z"
        };

        const recipes_3 =
        [{
            "id": 1,
            "name_en": "Croissants 1",
            "name_ar": "Croissants 1",
            "featured_image": "https://www.mazola.com.sa/uploads/images/croissant-min.jpg",
            "images": [{"url": "https://mazola-prod.s3.me-south-1.amazonaws.com/uploads/products/6281003105013/1.png", "name": "Screen Shot 2023-01-11 at 23.06.51.png"}, {"url": "https://mazola-prod.s3.me-south-1.amazonaws.com/Screen Shot 2023-01-11 at 23.07.35.png", "name": "Screen Shot 2023-01-11 at 23.07.35.png"}, {"url": "https://mazola-prod.s3.me-south-1.amazonaws.com/Screen Shot 2023-01-11 at 23.08.04.png", "name": "Screen Shot 2023-01-11 at 23.08.04.png"}],
            "ingredients_en": "<ul><li>1 kilo of flour</li><li>3 tablespoons of yeast</li><li>3 tablespoons of sugar</li><li>3 tablespoons of powdered milk</li><li>1 tablespoon salt</li><li>2 eggs</li><li>1/2 cup milk</li><li>1/2 cup of shortening from Mazola</li></ul>",
            "ingredients_ar": "<ul><li>1- Mix the dry ingredients together, then make a hole in the middle</li><li>2- Beat the eggs a little in a small plate until the whites mix with the yolks, then put them in the hole with the milk and shortening and rub the ingredients well</li><li",
            "instruction_en": "<ul><li>1- Mix the dry ingredients together, then make a hole in the middle</li><li>2- Beat the eggs a little in a small plate until the whites mix with the yolks, then put them in the hole with the milk and shortening and rub the ingredients well</li><li",
            "instruction_ar": "<ul><li>1- Mix the dry ingredients together, then make a hole in the middle</li><li>2- Beat the eggs a little in a small plate until the whites mix with the yolks, then put them in the hole with the milk and shortening and rub the ingredients well</li><li",
            "active": 1,
            "created_at": "2023-01-28T18:53:52.000Z",
            "updated_at": "2023-01-28T18:53:52.000Z"
        }];
    


    // const recipes_new = 
    //  {
    //    "id": recipes_1["id"],
    //     "name_en": recipes_1["title"],
    //     "name_ar": recipes_1["title"],
    //     "featured_image": recipes_1["images"],
    //     "images": [{"url": recipes_1["images"], "name": recipes_1["title"]}],
    //     "ingredients_en": recipes_1["description"],
    //     "ingredients_ar": recipes_1["description"],
    //     "instruction_en": recipes_1["content"],
    //     "instruction_ar": recipes_1["content"],
    //     "active": 1,
    // };

    // const recipes_new1 = recipes_1.map(recipe => {
    //   return {
    //     id: recipe.id,
    //     name_en: recipe.title,
    //     name_ar: recipe.title,
    //     featured_image: recipe.images,
    //     images: [{url: recipe.images, name: recipe.title}],
    //     ingredients_en: recipe.description,
    //     ingredients_ar: recipe.description,
    //     instruction_en: recipe.content,
    //     instruction_ar: recipe.content,
    //     active: 1
    //   }
    // });

    const recipes_new1 = recipes_1.map(recipe => {
      return {
        id: recipe.id,
        name_en: recipe.title,
        name_ar: recipe.title,
        featured_image: recipe.thumbnail,
        video_url: recipe.video_url,
        active: 1
      }
    });
    
    
    
    

    console.log(recipes_new1)
    return recipes_new1;

  }

  const handleUpload = async (file: any) => {
    console.log("file: ", file);
    const BUCKET_NAME = "mazola-prod";
    const s3 = new AWS.S3({
      region: process.env.REACT_APP_REGION,
      secretAccessKey: process.env.REACT_APP_SECRET,
      accessKeyId: process.env.REACT_APP_ACCESS_KEY,
    });
    //const readFile = util.promisify(fs.readFile);
    const data = file;
    const uploadToS3 = async (data:any) => {
      const name = file.name;
      await s3
        .putObject({
          Key: name,
          Bucket: BUCKET_NAME,
          ContentType: "image/jpg",
          Body: data,
          ACL: "public-read",
        })
        .promise();
      return `https://${BUCKET_NAME}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/${name}`;
    };
    const url = await uploadToS3(data);
    console.log(url);
  };
  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <ImageInput
          source={sourceName}
          multiple={multiple}
          onChange={(e) => {
            handleChange(e);
          }}
        >
          <ImageField source="src" />
        </ImageInput>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={(e) => {
            handleClick(e);
          }}
          disabled={!isChanged}
        >
          {translate("pos.upload")}
        </Button>
      </CardActions>
    </Card>
  );
};

export default UploadImages;
